exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search-actions h2{line-height:30px}.search-actions .actions{text-align:right}.search-actions .actions>div{margin-left:5px}.search-actions p{margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/node_modules/css-loader!/var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/components/search/NoSearchResults.css
// module id = 681
// module chunks = 0